<!--
 * @Description: 
 * @Author: xgx
 * @Date: 2022-10-13 09:57:02
 * @LastEditors: xgx
-->
<template>
  <div id="box" class="box">
    <div id="left" class="left">
      <div style="font-weight: 600" class="title">组织架构</div>
      <div class="search">
        <a-input-search
          v-model="organizationName"
          placeholder="搜索组织架构名称"
          size="large"
          @search="search"
        >
          <template #enterButton @click="search">
            <img class="img" src="@/assets/images/search.jpg" />
          </template>
        </a-input-search>
      </div>
      <div @click="expandHandle">
        <div v-if="expandAll">
          <img class="close-img" src="@/assets/images/close.jpg" /><span
            class="close-name"
            >全部收缩</span
          >
        </div>
        <div v-if="!expandAll">
          <img class="close-img" src="@/assets/images/open.jpg" /><span
            class="close-name"
            >全部展开</span
          >
        </div>
      </div>
      <a-spin :spinning="isTree">
        <div class="tree-box tree-container el-tree">
          <el-tree
            :data="treeData"
            ref="tree"
            node-key="id"
            :expand-on-click-node="false"
            :current-node-key="organization"
            :style="{
              height: heightLeft,
              overflowY: 'auto',
              overflowX: 'hidden',
            }"
            :default-expanded-keys="defaultShowNodes"
            class="tree"
            icon-class="icon-tree"
            @node-click="onSelect"
          >
          <!--  @node-expand="nodeExpand"
            @node-collapse="nodeCollapse" -->
            <div class="custom-tree-node" slot-scope="{ node, data }">
              <div class="tree-text">{{ node.label }}</div>
              <a-dropdown>
                <a-menu slot="overlay">
                  <a-menu-item
                    v-if="codeData.indexOf('123') != -1"
                    @click="addNodeFn(data.id, node.label)"
                    key="1"
                  >
                    添加</a-menu-item
                  >
                  <a-menu-item
                    v-if="codeData.indexOf('124') != -1"
                    @click="updateNodeFn(data)"
                    key="2"
                  >
                    编辑</a-menu-item
                  >
                  <a-menu-item
                    style="color: rgba(245, 108, 108, 1)"
                    @click="deleteNode(data)"
                    key="3"
                    v-if="codeData.indexOf('125') != -1"
                  >
                    删除</a-menu-item
                  >
                </a-menu>
                <div class="dian-box">
                  <i class="ri-more-2-fill icon-txt"></i>
                </div>
              </a-dropdown>
            </div>
          </el-tree>
        </div>
      </a-spin>
    </div>
    <div id="resize"></div>
    <div id="right" class="right">
      <div style="font-weight: 600" class="right-name">
        组织-{{ organizationNameTwo }}
      </div>
      <div class="log-box">
        <el-tabs v-model="activeName" type="card" @tab-click="handleClick">
          <el-tab-pane
            v-if="codeData.indexOf('121') != -1"
            label="管理员"
            name="first"
          ></el-tab-pane>
          <el-tab-pane
            v-if="codeData.indexOf('281') != -1"
            label="站点权限"
            name="second"
          ></el-tab-pane>
          <el-tab-pane
            v-if="codeData.indexOf('285') != -1"
            label="栏目权限"
            name="third"
          ></el-tab-pane>
          <el-tab-pane
            v-if="codeData.indexOf('289') != -1"
            label="稿件库权限"
            name="fourth"
          ></el-tab-pane>
        </el-tabs>
      </div>
      <!-- <div class="dir"></div> -->
      <div v-if="type == 1">
        <div class="top">
          <div>
            <el-button
              style="margin-bottom: 20px"
              type="primary"
              v-if="codeData.indexOf('131') != -1"
              @click="addAdminFn"
              >添加账号</el-button
            >
            <el-button v-if="isShowBtn" type="primary" @click="searchTwo"
              >查询</el-button
            >
          </div>
          <div class="search">
            <a-select
              v-if="!isShowBtn"
              mode="multiple"
              showArrow
              v-model:value="roleIds"
              :maxTagCount="1"
              style="width: 250px; margin-right: 12px"
              placeholder="按角色筛选"
            >
              <a-select-option
                :key="index"
                v-for="(item, index) in rolesData"
                :value="item.id"
                >{{ item.roleName }}</a-select-option
              >
            </a-select>
            <a-select
              mode="multiple"
              showArrow
              v-model:value="roleIds"
              :maxTagCount="1"
              v-if="isShowBtn"
              style="width: 250px; margin-right: 12px; margin-bottom: 20px"
              placeholder="按角色筛选"
            >
              <a-select-option
                :key="index"
                v-for="(item, index) in rolesData"
                :value="item.id"
                >{{ item.roleName }}</a-select-option
              >
            </a-select>
            <a-input-group compact>
              <a-select
                v-model:value="selectName"
                style="max-width: 140px; background: #ccc"
              >
                <a-select-option
                  @click="selectFn(item.value)"
                  :key="index"
                  v-for="(item, index) in selectArr"
                >
                  {{ item.label }}
                </a-select-option>
              </a-select>
              <a-input
                v-model:value="value"
                placeholder="请输入搜索内容"
                style="max-width: 173px; margin-right: 12px"
              />
            </a-input-group>
            <el-button v-if="!isShowBtn" type="primary" @click="searchTwo"
              >查询</el-button
            >
          </div>
        </div>
        <coententTable
          :y="height"
          @handleTableChange="handleTableChange"
          @onShowSizeChange="onShowSizeChange"
          :columns="type == 1 ? columns : columnsTwo"
          :dataSource="dataSource"
          :customSlot="customSlot"
          :loading="loading"
        >
          <template v-slot:operation="scopeVal">
            <div style="display: flex">
              <div
                class="btnTwo"
                @click="editUser(scopeVal.scope)"
                v-if="codeData.indexOf('132') != -1"
                style="margin-right: 14px"
              >
                编辑
              </div>
              <div
                @click="open(scopeVal.scope)"
                class="btnThree"
                v-if="codeData.indexOf('133') != -1"
              >
                删除
              </div>
            </div>
          </template>
        </coententTable>
        <div id="pagination" class="pagination">
          <div class="switch">
            <a-switch v-model="switchOpen" @change="onChange" />
            <span class="cy-txt">仅展示直属成员</span>
          </div>
          <a-pagination
            :current="pagination.current"
            :pageSize="pagination.pageSize"
            show-size-changer
            :pager-count="5"
            show-quick-jumper
            :total="pagination.total"
            @change="onShowSizeChange"
            @showSizeChange="handleTableChange"
            :page-size-options="pagination.pageSizeOptions"
            :show-total="(total) => `共 ${pagination.total} 条`"
          />
        </div>
      </div>
      <SiteRole
        ref="siteRole"
        :organizationId="organization"
        v-if="type == 2"
      />
      <columnRole :organizationId="organization" v-if="type == 3" />
      <SectionLibraryPermissions v-if="type == 4" :orgId="organization" />
    </div>
    <AddOrgan
      @close="close"
      :itemAdd="itemAdd"
      :item="item"
      :resData="listData"
      @closeTwo="closeTwoAdd"
      :visible="visible"
    />
    <addAdmin
      :rolesDataTwo="rolesData"
      @close="closeTwo"
      @closeTwo="closeTwoAddTwo"
      :visible="visibleTwo"
      :item="itemTwo"
      :addUserDataId="addUserDataId"
    ></addAdmin>
    <el-dialog
      title="确认删除管理员?"
      :visible.sync="dialogVisibleTwo"
      width="450px"
      custom-class="tips-box"
      top="17%"
    >
      <span
        >管理员删除是不可以逆的操作，删除后，与该角色关联的管理员账号将失去管理权限</span
      >
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisibleTwo = false">取消</el-button>
        <el-button :loading="deleteShow" type="danger" @click="deleteFnTwo"
          >确认删除</el-button
        >
      </span>
    </el-dialog>
    <el-dialog
      title="确认删除组织？"
      :visible.sync="dialogVisibleOrg"
      width="450px"
      custom-class="tips-box"
      top="17%"
    >
      <span
        >组织删除是不可逆的操作，删除后，与该组织关联的管理员账号将失去管理权限。</span
      >
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisibleOrg = false">取消</el-button>
        <el-button :loading="deleteShowTwo" type="danger" @click="deleteFnOrg"
          >确认删除</el-button
        >
      </span>
    </el-dialog>
  </div>
</template>

<script>
import coententTable from "@/components/coentent_table.vue";
import AddOrgan from "./add_organ.vue";
import addAdmin from "../AdministratorManagement/add_administrator.vue";
import SiteRole from "./siteRole.vue";
import columnRole from "./columnRole.vue";
import SectionLibraryPermissions from "./section_library_permissions.vue";
import {
  organTree,
  list,
  roleList,
  deleteOne,
  deleteFn,
  selectSiteListByOrgId,
} from "./organizational_structure";
import { message } from "ant-design-vue";
export default {
  data() {
    return {
      type: 1,
      height: 0,
      switchOpen: true,
      visible: false,
      isShowBtn: false,
      deleteShow: false,
      visibleTwo: false,
      isBtnShow: false,
      itemTwo: false,
      isCloseAll: false,
      deleteShowTwo: false,
      heightLeft: 0,
      heightTwo: 0,
      selectValue: 1,
      value: "",
      expandedKeys: [],
      selectedKeys: [],
      addUserDataId: "",
      siteList: [],
      listData: [],
      deleteItem: {},
      itemAdd: {},
      item: {},
      roleIds: [],
      treeData: [],
      selectName: "管理员姓名",
      selectArr: [
        {
          label: "管理员姓名",
          value: "1",
        },
        {
          label: "手机号",
          value: "2",
        },
      ],
      defaultProps: {
        children: "children",
        label: "name",
      },
      organization: "",
      organizationName: "",
      organizationNameTwo: "",
      name: "",
      loading: false,
      role: undefined,
      columns: [
        {
          title: "管理员姓名",
          dataIndex: "name",
          ellipsis: true,
          width: 150,
          ellipsis: true,
        },
        {
          title: "登录手机号",
          dataIndex: "phone",
          width: 150,
          ellipsis: true,
        },
        {
          title: "所属组织",
          dataIndex: "organizationName",
          ellipsis: true,
          customCell: (column) => {
            return {
              style: {
                "min-width": "220px",
                "max-width": "400px",
              },
            };
          },
          customHeaderCell: (column) => {
            return {
              style: {
                "min-width": "220px",
                "max-width": "400px",
              },
            };
          },
        },
        {
          title: "角色类型",
          dataIndex: "roleName",
          width: 150,
          ellipsis: true,
        },
        {
          title: "操作",
          dataIndex: "operate",
          scopedSlots: { customRender: "action" },
          width: 174,
          fixed: "right",
        },
      ],
      customSlot: [
        {
          name: "name",
          customRender: "name",
        },
        {
          name: "state",
          customRender: "state",
        },
      ],
      columnsTwo: [
        {
          title: "微信公众号",
          dataIndex: "name",
          scopedSlots: { customRender: "name" },
          customCell: (column) => {
            return {
              style: {
                "min-width": "220px",
                "max-width": "400px",
              },
            };
          },
          customHeaderCell: (column) => {
            return {
              style: {
                "min-width": "220px",
                "max-width": "400px",
              },
            };
          },
        },
        {
          title: "状态",
          dataIndex: "state",
          width: 120,
          scopedSlots: { customRender: "state" },
        },
        {
          title: "授权人",
          dataIndex: "grantName",
          width: 120,
        },
        {
          title: "授权时间",
          dataIndex: "grantTime",
          width: 200,
        },
        {
          title: "权限刷新时间",
          dataIndex: "refreshTime",
          width: 200,
        },
      ],
      pagination: {
        current: 1,
        pageSize: 15,
        total: 0,
        pageSizeOptions: ["15", "25", "35"],
      },
      dataSource: [],
      cancelPreAuth: false,
      codeData: [],
      rolesData: [],
      isTree: false,
      dialogVisibleTwo: false,
      expandAll: true,
      dialogVisibleOrg: false,
      orgItem: {},
      activeName: "first",
      defaultShowNodes: [],
    };
  },
  components: {
    coententTable,
    AddOrgan,
    addAdmin,
    SiteRole,
    columnRole,
    SectionLibraryPermissions,
  },
  mounted() {
    this.codeData = JSON.parse(sessionStorage.getItem("menuData"));
    this.heightLeft = `${document.documentElement.clientHeight - 285}px`;
    if (
      this.codeData.indexOf("121") == -1 &&
      this.codeData.indexOf("281") == -1 &&
      this.codeData.indexOf("285") == -1
    ) {
      this.activeName = "fourth";
      this.type = 4;
      this.changeType(this.type);
      return;
    } else if (
      this.codeData.indexOf("121") == -1 &&
      this.codeData.indexOf("281") == -1
    ) {
      this.activeName = "third";
      this.type = 3;
      this.changeType(this.type);
      return;
    } else if (this.codeData.indexOf("121") == -1) {
      this.activeName = "second";
      this.type = 2;
      this.changeType(this.type);
      return;
    }
    this.getOrganTree();
    this.rolesList();
    let _this = this;
    this.$nextTick(() => {
      var left = document.getElementById("left");
      var box = document.getElementById("box");
      var right = document.getElementById("right");
      var pagination = document.getElementById("pagination");
      left.style.width = 348 + "px";
      right.style.width = box.clientWidth - 348 - 5 + "px";
      pagination.style.width = box.clientWidth - 348 + 5 + "px";
      if (box.clientWidth - 250 - 5 < 1000) {
        document.getElementsByClassName(
          "ant-pagination"
        )[0].style.marginRight = 0;
        document.getElementsByClassName(
          "ant-pagination-options"
        )[0].style.display = "none";
      } else {
        document.getElementsByClassName("ant-pagination")[0].style.marginRight =
          "124px";
        document.getElementsByClassName(
          "ant-pagination-options"
        )[0].style.display = "block";
      }
      if (box.clientWidth - 250 - 5 < 720) {
        _this.height = document.documentElement.clientHeight - 580
        _this.isShowBtn = true;
      } else {
        _this.isShowBtn = false;
      }
    });
    this.getLeftMove();
  },
  methods: {
    handleClick() {
      if (this.activeName == "first") {
        this.type = 1;
        this.changeType(1);
      }
      if (this.activeName == "second") {
        this.type = 2;
        this.changeType(2);
      }
      if (this.activeName == "third") {
        this.type = 3;
        this.changeType(3);
      }
      if (this.activeName == "fourth") {
        this.type = 4;
        this.changeType(4);
      }
    },
    getLeftMove() {
      var resize = document.getElementById("resize");
      var left = document.getElementById("left");
      var right = document.getElementById("right");
      var box = document.getElementById("box");
      let _this = this;
      var pagination = document.getElementById("pagination");
      resize.onmousedown = function (e) {
        var startX = e.clientX;
        resize.left = resize.offsetLeft;
        document.onmousemove = function (e) {
          var endX = e.clientX;

          var moveLen = resize.left + (endX - startX);
          var maxT = box.clientWidth - resize.offsetWidth;
          if (moveLen < 348) moveLen = 348;
          if (moveLen > 600) moveLen = 600;
          if (moveLen > maxT - 150) moveLen = maxT - 150;

          resize.style.left = moveLen;
          left.style.width = moveLen + "px";
          right.style.width = box.clientWidth - moveLen - 5 + "px";
          pagination.style.width = box.clientWidth - moveLen + 5 + "px";
          if (box.clientWidth - moveLen - 5 < 1250) {
            _this.height = document.documentElement.clientHeight - 480;
            document.getElementsByClassName(
              "ant-pagination"
            )[0].style.marginRight = 0;
            document.getElementsByClassName(
              "ant-pagination-options"
            )[0].style.display = "none";
          } else {
            document.getElementsByClassName(
              "ant-pagination"
            )[0].style.marginRight = "124px";
            document.getElementsByClassName(
              "ant-pagination-options"
            )[0].style.display = "block";
            _this.height = document.documentElement.clientHeight - 460;
          }
          if (box.clientWidth - moveLen - 5 < 720) {
            _this.isShowBtn = true;
            _this.height = document.documentElement.clientHeight - 580;
          } else {
            _this.isShowBtn = false;
          }
        };
        document.onmouseup = function (evt) {
          document.onmousemove = null;
          document.onmouseup = null;
          resize.releaseCapture && resize.releaseCapture();
        };
        resize.setCapture && resize.setCapture();
        return false;
      };
    },
    searchTwo() {
      this.pagination.current = 1;
      this.getListPage();
    },
    deleteFnOrg() {
      this.deleteShowTwo = true;
      deleteFn({ id: this.orgItem.id }).then((res) => {
        if (res.code == 0) {
          this.getOrganTree();
          this.dialogVisibleOrg = false;
          this.deleteShowTwo = false;
          message.success(res.msg);
        }
      });
    },
    expandHandle() {
      console.log(this.$refs.tree.store);
      this.expandAll = !this.expandAll;
      this.expandNodes(this.$refs.tree.store.root);
    },
    // 遍历树形数据，设置每一项的expanded属性，实现展开收起
    expandNodes(node) {
      node.expanded = this.expandAll;
      for (let i = 0; i < node.childNodes.length; i++) {
        node.childNodes[i].expanded = this.expandAll;
        if (node.childNodes[i].childNodes.length > 0) {
          this.expandNodes(node.childNodes[i]);
        }
      }
    },
    onChange(e) {
      this.switchOpen = e;
      this.getListPage();
    },
    closeTwo() {
      this.visibleTwo = false;
      this.getListPage();
    },
    closeTwoAddTwo() {
      this.visibleTwo = false;
    },
    closeTwoAdd() {
      this.visible = false;
    },
    open(item) {
      this.dialogVisibleTwo = true;
      this.deleteItem = item;
    },
    rolesList() {
      roleList({
        current: 1,
        size: 1000000,
      }).then((res) => {
        if (res.code == 0) {
          this.rolesData = res.data.records;
        }
      });
    },
    addNodeFn(id, organizationName) {
      this.item = JSON.parse(JSON.stringify({}));
      this.itemAdd = { id, organizationName };
      this.visible = true;
    },
    updateNodeFn(node) {
      this.item = node;
      this.itemAdd = {};
      this.item.organizationName = node.label;
      this.item = JSON.parse(JSON.stringify(this.item));
      this.visible = true;
    },
    deleteNode(node) {
      this.dialogVisibleOrg = true;
      this.orgItem = node;
    },
    editUser(item) {
      this.itemTwo = JSON.parse(JSON.stringify(item));
      this.visibleTwo = true;
    },
    addAdminFn() {
      this.itemTwo = {};
      this.addUserDataId = this.organization;
      this.visibleTwo = true;
    },
    close() {
      this.visible = false;
      this.getOrganTree();
    },
    changeType(type) {
      if (type == 3) {
        selectSiteListByOrgId({
          id: this.organization,
        }).then((res) => {
          if (res.code == 0) {
            if (res.data.length == 0) {
              message.error("请选择站点");
              return;
            }
          }
        });
      }
      this.type = type;
      if (this.type == 1) {
        let _this = this;
        this.$nextTick(() => {
          var left = document.getElementById("left");
          var box = document.getElementById("box");
          var right = document.getElementById("right");
          var pagination = document.getElementById("pagination");
          left.style.width = 348 + "px";
          right.style.width = box.clientWidth - 348 - 5 + "px";
          pagination.style.width = box.clientWidth - 348 + 5 + "px";
          if (box.clientWidth - 250 - 5 < 1250) {
             this.height = document.documentElement.clientHeight - 480;
            document.getElementsByClassName(
              "ant-pagination"
            )[0].style.marginRight = 0;
            document.getElementsByClassName(
              "ant-pagination-options"
            )[0].style.display = "none";
          } else {
            document.getElementsByClassName(
              "ant-pagination"
            )[0].style.marginRight = "124px";
            document.getElementsByClassName(
              "ant-pagination-options"
            )[0].style.display = "block";
             this.height = document.documentElement.clientHeight - 460;
          }
          if (box.clientWidth - 250 - 5 < 720) {
            _this.isShowBtn = true;
            _this.height = document.documentElement.clientHeight - 580;
          } else {
            _this.isShowBtn = false;
          }
          this.getLeftMove();
        });
        this.getListPage();
      }
    },
    onSelect(data) {
      this.organization = data.id;
      this.organizationNameTwo = data.label;
      this.pagination.current = 1;
      if (this.type == 1) {
        this.getListPage();
      }
    },
    // nodeExpand(data) {
    //   this.defaultShowNodes.push(data.id);
    // },
    // nodeCollapse(data) {
    //   for (let index = 0; index < this.defaultShowNodes.length; index++) {
    //     const element = this.defaultShowNodes[index];
    //     if (element == data.id) {
    //       this.defaultShowNodes.splice(index, 1);
    //     }
    //   }
    // },
    deleteFnTwo() {
      this.deleteShow = true;
      deleteOne({ id: this.deleteItem.id }).then((res) => {
        if (res.code == 0) {
          this.dialogVisibleTwo = false;
          this.deleteShow = false;
          this.getListPage();
        }
      });
    },
    search() {
      this.getOrganTree();
    },
    // 切换 搜索
    selectFn(value) {
      this.selectValue = value;
    },
    onShowSizeChange(current) {
      this.pagination.current = current;
      this.getListPage();
    },
    handleTableChange(page, pageSize) {
      this.pagination.current = 1;
      this.pagination.pageSize = pageSize;
      this.getListPage();
    },
    //授权列表数据
    getListPage() {
      this.loading = true;
      list({
        current: this.pagination.current,
        size: this.pagination.pageSize,
        type: this.selectValue,
        roleIds: this.roleIds.join(","),
        organs: this.organization,
        value: this.value,
        childrenType: this.switchOpen ? 1 : 2,
      }).then((res) => {
        this.dataSource = res.data.records;
        this.pagination.current = res.data.current;
        this.pagination.total = res.data.total;
        this.height = 0;
        if (this.pagination.total > 0) {
          this.heightLeft = `${document.documentElement.clientHeight - 285}px`;
           var box = document.getElementById("box");
           if((box.clientWidth - 250 - 5) < 1250){
                       this.height = document.documentElement.clientHeight - 480;
                       console.log(this.height,'sadasd')
                 }else{
                      this.height = document.documentElement.clientHeight - 460;
                 }
          window.onresize = () => {
            return (() => {
              this.height = document.documentElement.clientHeight - 460;
              this.heightLeft = `${
                document.documentElement.clientHeight - 285
              }px`;
              var left = document.getElementById("left");
              var box = document.getElementById("box");
              var right = document.getElementById("right");
              var pagination = document.getElementById("pagination");
              left.style.width = 348 + "px";
              right.style.width = box.clientWidth - 348 - 5 + "px";
              pagination.style.width = box.clientWidth - 348 + 5 + "px";
              if (box.clientWidth - 250 - 5 < 1250) {
                 this.height = document.documentElement.clientHeight - 480;
                document.getElementsByClassName(
                  "ant-pagination"
                )[0].style.marginRight = 0;
                document.getElementsByClassName(
                  "ant-pagination-options"
                )[0].style.display = "none";
              } else {
                 this.height = document.documentElement.clientHeight - 460;
                document.getElementsByClassName(
                  "ant-pagination"
                )[0].style.marginRight = "124px";
                document.getElementsByClassName(
                  "ant-pagination-options"
                )[0].style.display = "block";
              }
              if (box.clientWidth - 250 - 5 < 720) {
                this.height = document.documentElement.clientHeight - 580;
                this.isShowBtn = true;
              } else {
                this.isShowBtn = false;
              }
            })();
          };
        }
        if (this.dataSource.length == 0 && this.pagination.current != 1) {
          this.pagination.current = this.pagination.current - 1;
          this.getList();
        }
        this.loading = false;
      });
    },
    getOrganTree() {
      const _this = this;
      this.isTree = true;
      organTree({ name: _this.organizationName }).then((res) => {
        if (res.code == 0) {
          if (res.data.length > 0) {
            this.organization = res.data[0].id;
            this.organizationNameTwo = res.data[0].organizationName;
            if (this.defaultShowNodes.length == 0) {
              this.defaultShowNodes = [res.data[0].id];
            }
          }
          if (this.type == 1) {
            this.getListPage();
          }
          let options = JSON.stringify(res.data)
            .replace(/organizationName/g, "label")
            .replace(/id/g, "id");
          this.$nextTick(() => {
            _this.treeData = JSON.parse(options);
            _this.listData = JSON.parse(options);
          });
        }
        this.isTree = false;
      });
    },
  },
};
</script>

<style lang="less" scoped>
.box {
  display: flex;
  width: 100%;
  height: calc(90% - 11px);
  position: relative;
  .left {
    font-size: 14px;
    color: #000;
    padding: 24px;
    width: 348px;
    height: calc(107.5% - 3px);
    border-right: solid 1px #E4E7ED;
    .title {
      margin-bottom: 24px;
    }
    .search {
      margin-bottom: 12px;
    }
    /deep/ .ant-btn-primary {
      background: #1890ff;
      padding: 0 5px;
    }
    /deep/ input::-webkit-input-placeholder {
      color: #415058;
    }
    /deep/ .ant-input {
      background: #f7f7f7;
    }
  }
  .right {
    flex: 1;
    height: 100%;
    width: 100%;
    font-size: 14px;
    padding-top: 24px;
    width: 500px;
    .right-name {
      padding-left: 24px;
      color: #000;
    }
    .log-box {
      //border-bottom: solid 1px #dcdfe6;
      //display: flex;
      margin-left: 24px;
      margin-right: 24px;
      margin-top: 25px;
      // .log {
      //   padding: 10px 20px;
      //   border-top: solid 1px #dcdfe6;
      //   border-left: solid 1px #dcdfe6;
      //   cursor: pointer;
      //   border-bottom: solid 1px #dcdfe6;
      //   background: #F5F7FA;
      // }
      // .log:last-child {
      //   border-right: solid 1px #dcdfe6;

      // }
      // .log:first-child {

      // }
    }
    .search {
      display: flex;
      margin-bottom: 20px;
      flex-wrap: wrap;
      /deep/ .ant-input-group {
        width: auto;
      }
      /deep/ .ant-select-selection {
        background-color: rgba(245, 247, 250, 1);
        height: 40px;
      }
      /deep/ .ant-input {
        background-color: rgba(245, 247, 250, 1);
        height: 40px;
      }
      /deep/ .el-input__inner {
        background-color: rgba(245, 247, 250, 1);
        height: 40px;
      }
      /deep/ input::-webkit-input-placeholder {
        color: rgba(102, 111, 128, 1);
      }
      /deep/ .ant-select-selection__placeholder {
        color: rgba(102, 111, 128, 1);
      }
      /deep/ .ant-select-selection__rendered {
        line-height: 39px;
      }
      /deep/ .el-select__tags {
        white-space: nowrap;
        overflow: hidden;
      }
      /deep/ .el-select__tags {
        flex-wrap: nowrap;
      }
    }

    /deep/ .ant-table-wrapper {
      // width: 100%;
    }
  }
}
.top {
  padding: 24px;
  padding-bottom: 0px;
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
  .search {
    display: flex;
  }

  .add-img {
    margin-top: -2px;
    margin-right: 3px;
  }
}
.el-tree {
  overflow-y: auto;
}
.dir {
  height: 1px;
  background: #dcdfe6;
  margin-left: 24px;
  margin-right: 24px;
  margin-top: -1px;
}
.middle {
  //height: calc(113% - 4px);
  width: 1px;
  background: #f4f4f6;
}
.tr-one {
  display: flex;
}
.quan {
  width: 24px;
  height: 24px;
  background: #fff;
  border: solid 1px #ccc;
  border-radius: 50%;
}
.close-name {
  color: #303133;
  font-weight: 400;
  margin-top: 4px;
}
.close-img {
  margin-top: -1px;
  margin-right: 4px;
  cursor: pointer;
}
.Status1 {
  color: #67c23a;
}
.Status2 {
  color: #f56c6c;
}
.btn {
  margin-top: 24px;
  text-align: right;
}
/deep/ .ant-pagination-options {
  float: left;
  margin-right: 6px;
}
/deep/ .ant-pagination-total-text {
  float: left;
}
/deep/ .ant-pagination-options-quick-jumper {
  position: absolute;
  right: 20px;
}
/deep/ .ant-pagination {
  margin-right: 124px;
}
.pagination {
  display: flex;
  padding: 12px;
  padding-right: 0px;
  flex-direction: column;
  align-items: flex-end;
  border-top: solid #E4E7ED 1px;
  position: absolute;
  bottom: 0;
  padding-right: 24px;
  width: calc(100% - 627px);
  margin-left: -5px;
}
/deep/ .ant-pagination-item-active {
  background: #1890ff;
}
/deep/ .ant-pagination-item-active a {
  color: #fff;
}
.overflow {
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  -o-text-overflow: ellipsis;
  width: 150px;
}
.dian {
  width: 3px;
  height: 3px;
  border: 1px solid #303133;
  border-radius: 100px;
  background-color: #303133;
  display: block;
  margin-bottom: 1px;
  margin-top: 1px;
}
.dian-box {
  margin-top: 3px;
  padding-left: 20px;
  margin-right: 10px;
  text-align: center;
  position: relative;
  .icon-txt {
    font-weight: bold;
    color: #000;
    font-size: 16px;
    position: absolute;
    top: -10px;
    right: -10px;
    bottom: -10px;
    left: -20px;
  }
}
/deep/ .custom-tree-node {
  display: flex;
  align-items: center;
  width: 100%;
  justify-content: space-between;
}
/* 树形结构节点添加连线 */
.tree /deep/ .el-tree-node {
  position: relative;
  padding-left: 16px;
}

.tree /deep/ .el-tree-node__children {
  padding-left: 16px;
}

.tree /deep/ .el-tree-node :last-child:before {
  height: 38px;
}

.tree /deep/ .el-tree > .el-tree-node:before {
  border-left: none;
}

.tree-container /deep/ .el-tree > .el-tree-node:after {
  border-top: none;
}

.tree /deep/ .el-tree-node:before {
  content: "";
  left: -4px;
  position: absolute;
  right: auto;
  border-width: 1px;
}

.tree /deep/ .el-tree-node:after {
  content: "";
  left: -4px;
  position: absolute;
  right: auto;
  border-width: 1px;
}
.tree /deep/ .el-tree-node__expand-icon.is-leaf {
  display: none;
}

.tree /deep/ .el-tree-node:before {
  border-left: 1px dashed #b8b9bb;
  bottom: 0px;
  height: 100%;
  top: -26px;
  width: 1px;
}

.tree /deep/ .el-tree-node:after {
  border-top: 1px dashed #b8b9bb;
  height: 20px;
  top: 12px;
  width: 24px;
}

.tree-box {
  margin-left: -15px;
  /deep/ .el-tree-node__content {
    padding-left: 0px !important;
  }
  .tree-text {
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    //width: 154px;
  }

  /deep/ .icon-tree {
    position: relative;
    width: 26px;
    height: 24px;
    background: url("../../../assets/images/open.jpg");
    background-size: 100% 100%;
  }
  /deep/ .expanded {
    background: url("../../../assets/images/close.jpg");
    background-size: 100% 100%;
    width: 27px;
    height: 24px;
  }
  /deep/ .is-leaf {
    background-image: none;
    background-size: 100% 100%;
  }
  /deep/ .el-tree-node__expand-icon {
    transform: initial;
    transition: auto;
  }
}
/deep/ .ant-dropdown-menu-item {
  padding: 3px 20px;
}
/deep/ .el-icon-caret-right:before {
  //font-size: 16px;
}
.switch {
  position: absolute;
  left: 12px;
  display: flex;
  align-items: center;
}
.cy-txt {
  color: rgba(102, 111, 128, 1);
  font-size: 14px;
  font-family: HarmonyOS_Sans_SC-regular;
  margin-left: 10px;
}
/deep/ .table {
  margin-bottom: 20px;
}
/deep/ .ant-spin-nested-loading {
  width: 100%;
}
.el-button--primary {
  background: #176de6;
}
.btnTwo {
  border-radius: 3px;
  background-color: rgba(240, 246, 255, 1);
  color: rgba(23, 109, 230, 1);
  font-size: 12px;
  font-family: Roboto;
  border: 1px solid rgba(23, 109, 230, 1);
  width: 56px;
  height: 28px;
  line-height: 16px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
}
.btnThree {
  width: 56px;
  height: 28px;
  line-height: 16px;
  border-radius: 3px;
  background-color: rgba(255, 242, 242, 1);
  color: rgba(245, 108, 108, 1);
  font-size: 12px;
  text-align: center;
  font-family: Roboto;
  border: 1px solid rgba(245, 108, 108, 1);
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
}
.btnFour {
  width: 56px;
  height: 28px;
  line-height: 16px;
  border-radius: 3px;
  background-color: rgba(244, 244, 245, 1);
  color: rgba(144, 147, 153, 1);
  font-size: 12px;
  text-align: center;
  font-family: Roboto;
  border: 1px solid rgba(211, 212, 214, 1);
  display: flex;
  justify-content: center;
  align-items: center;
}
/deep/ .el-tabs__header {
  margin: 0px;
}
#resize {
  width: 5px;
  cursor: w-resize;
  float: left;
}
/deep/ .table {
  margin-top: 0px;
}
</style>